<template>
  <el-drawer class="drawer" ref="drawer" :visible.sync="drawer" :direction="direction" :destroy-on-close="true" @opened="getlist" :size="size">

  </el-drawer>
</template>

<script>
export default {
  components: {},
  props: {
    // 弹框大小
    size: {
      type: String,
      default: '1080px'
    },
  },
  filters: {
    // 状态
  },
  data() {
    return {
      drawer: false, // 弹窗
      direction: 'rtl',
      sourceData: {}, // 数据源
      activeName: '1',
      accessPoint: this.$store.getters.accessPoint, //权限点

    }
  },

  methods: {
    // 初始化
    init(row) {
      this.activeName = 1
      this.drawer = true
      this.sourceData = row

      // outsource_flowDetail(row.id).then((response) => {
      //     if (response.code == 1) {
      //         this.sourceData = response.data;
      //     }
      // });
    },

    // 获取数据列表
    getlist() {

    },

  }
}
</script>

<style lang="scss" scoped>
.drawer {
  ::v-deep .el-drawer__header {
    margin-bottom: 0;
    padding: 0 32px;
    height: 56px;
    border-bottom: 1px solid #e5e5e5;
    box-shadow: 0px -1px 0px 0px #e5e5e5;
  }
  ::v-deep .el-drawer__close-btn {
    font-size: 24px;
    color: #999999;
  }

  .title-box {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;

    .butn-status {
      padding: 4px 8px;
      border-radius: 4px;
      margin-right: 12px;
      font-size: 14px;
      color: #ffffff;
    }
    .butn-status-red {
      background: #fb6c75;
    }
    .butn-status-blue {
      background: #439de2;
    }
    .butn-status-purple {
      background: #876fff;
    }
    .butn-status-yellow {
      background: #ffa356;
    }
    .butn-status-green {
      background: #0ed27f;
    }
    .butn-status-gray {
      background: #cccccc;
    }
    .title {
      font-size: 16px;
      color: #333333;
      line-height: 22px;
    }
  }

  ::v-deep.el-drawer__body {
    background: #f5f5f5;
  }

  ::v-deep .el-radio-group {
    width: 100%;
    padding: 0 73px;
    height: 54px;
    line-height: 54px;
    background: #ffffff;
  }

  ::v-deep.el-radio-button__inner {
    padding: 0 65px;
    font-size: 16px;
    font-weight: 500;
    color: #999999;
    border: 0;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: -20px;
      transform: translateX(-50%);
      width: 80px;
      height: 4px;
    }
  }

  ::v-deep.el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #333333;
    background-color: transparent;
    box-shadow: none;
    &::after {
      background: #3a89ff;
    }
  }
}

::v-deep :focus {
  outline: 0;
}
</style>